import React from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PaymentPortal from './components/PaymentPortal';
import ErrorComponent from './components/ErrorComponent';
import { LanguageProvider, useLanguage } from './i18n/LanguageProvider';

// Wrapper to provide props and localization to ErrorComponent
const ErrorRoute: React.FC = () => {
  const { t } = useLanguage();
  const { search } = useLocation();
  const message =
    new URLSearchParams(search).get('message') || t('cancelError');
  return (
    <ErrorComponent
      error={message}
      showRetryButton={false}
    />
  );
};

const AppContent: React.FC = () => (
  <>
    <Router>
      <Routes>
        <Route path="/" element={<PaymentPortal />} />
        <Route path="/response-error" element={<ErrorRoute />} />
      </Routes>
    </Router>
  </>
);

const App: React.FC = () => (
  <div className="min-h-screen">
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  </div>
);

export default App;